import { render, staticRenderFns } from "./ProductTeasers.vue?vue&type=template&id=7d7a929a&"
import script from "./ProductTeasers.vue?vue&type=script&lang=js&"
export * from "./ProductTeasers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports